export const GET_TIER_REQUEST = 'GET_TIER_REQUEST';
export const GET_TIER_DATA = 'GET_TIER_DATA';
export const GET_TIER_ERROR = 'GET_TIER_ERROR';